import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import messageEnums from 'enums/messages';
import overrideStyle from 'lib/overrideStyle';
import LoadingPlaceholder from '../components/icons/LoadingPlaceholder';

export function DataRequestStatusBanner(props) {
  if (!props.statusBannerAssets) {
    return null;
  }
  return (
    <Wrapper>
      <StatusBanner backgroundColor={props.statusBannerAssets.backgroundColor}>
        <StatusBannerTextWrapper>
          <StatusBannerText color={props.statusBannerAssets.color}>{props.statusBannerAssets.text}</StatusBannerText>
          {props.statusBannerAssets.shouldShowWaitingDots ? (
            <LoadingWrapper>
              <LoadingPlaceholder color="#888" size="10px" />
            </LoadingWrapper>
          ) : null}
        </StatusBannerTextWrapper>
      </StatusBanner>
    </Wrapper>
  );
}

DataRequestStatusBanner.propTypes = {
  statusBannerAssets: PropTypes.object.isRequired,
};

const LoadingWrapper = overrideStyle('span')`
  display: inline-block;
  height: 16px;
  margin-top: 8px;
  overflow: hidden;
  width: 30px;
`;

const StatusBannerText = overrideStyle('span')`
  color: ${p => p.color};
  float: left;
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 13px;
  font-weight: bold;
  margin: 10px 6px 10px 0px;
  text-align: center;
`;

const StatusBannerTextWrapper = overrideStyle('div')`
  margin: 0 auto;
  text-align: center;
  width: 100%
`;

const StatusBanner = overrideStyle('div')`
  display: flex;
  justify-content: center;
  flex-direction: column
  background-color: ${p => p.backgroundColor};
  height: 32px;
  margin-top: auto;
  width: 100%;
  overflow: hidden;
`;

const Wrapper = overrideStyle('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

function handleStatusAssets(status) {
  switch (status) {
    case messageEnums.SECURE_DATA_REQUEST_STATUSES.COMPLETED:
      return {
        color: '#FFFFFF',
        backgroundColor: '#009B00',
        text: 'Payment accepted!',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_REQUEST_STATUSES.DECLINED:
      return {
        backgroundColor: '#F6F6F6',
        color: '#D50E0E',
        text: 'Payment declined',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_REQUEST_STATUSES.ERROR:
      return {
        backgroundColor: 'red',
        color: '#1D1C1C',
        text: 'Error',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_REQUEST_STATUSES.SUBMITTED:
      return {
        backgroundColor: '#F6F6F6',
        color: '#1D1C1C',
        text: 'Waiting for agent',
        shouldShowWaitingDots: true,
      };
    case messageEnums.SECURE_DATA_REQUEST_STATUSES.TIMED_OUT:
      return {
        backgroundColor: '#F6F6F6',
        color: '#1D1C1C',
        text: 'Timed out',
        shouldShowWaitingDots: false,
      };
  }
}

export const mapStateToProps = (state, props) => {
  let status = props.status;
  return {
    statusBannerAssets: handleStatusAssets(status),
  };
};

const DataRequestStatusBannerContainer = connect(
  mapStateToProps,
  null
)(DataRequestStatusBanner);

export default DataRequestStatusBannerContainer;
